import BaseClient from '@/app/model/api/response/baseApiClient'
import { fieldDetailsApiFlag } from '@/app/model/store/domain/const'

class FieldDetailsApi extends BaseClient {
  public getFieldDetailsData (id: string, fieldFlag: boolean, flag: number, searchList: {[key:string]: any}, ownerList: number[]) {
    const path = '/v1/field/detail'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    // 1=マップ・圃場一覧 2=マイページ用 3=圃場選択モーダル
    /* trueの場合area_id、falseの場合planting_id */
    if (fieldFlag) {
      params.append('accordion_relation_id', id)

      if (flag === fieldDetailsApiFlag.FLAG_FIELD) {
        // 圃場検索の場合
        if (searchList.refile) {
          params.append('is_plant', '0')
        } else {
          params.append('is_plant', '1')
        }
        if (searchList.stage !== '' && searchList.stage !== 0) {
          params.append('growth_stage_id', searchList.stage)
        }
        if (searchList.variety !== '') {
          params.append('variety_id', searchList.variety)
        }
        if (searchList.risk !== 0) {
          params.append('risk_id', String(searchList.risk))
        }
        if (searchList.word !== '') {
          params.append('word', String(searchList.word))
        }
        params.append('accordion_id', searchList.accordion)
        url.search = params.toString()
      } else if (flag === fieldDetailsApiFlag.FLAG_MYPAGE) {
        // マイページデータ取得の場合
        params.append('is_plant', '1')
        for (var i in ownerList) {
          params.append('field_id[]', String(ownerList[i]))
        }
        url.search = params.toString()
      } else if (flag === fieldDetailsApiFlag.FLAG_MODAL) {
        params.append('is_plant', '1')
        if (searchList.status !== '') {
          params.append('growth_stage_id', searchList.status)
        }
        if (searchList.variety !== '') {
          params.append('variety_name', searchList.variety)
        }
        if (searchList.risk !== 0) {
          params.append('risk_id', String(searchList.risk))
        }
        if (searchList.word !== '') {
          params.append('word', String(searchList.word))
        }
        for (var j in ownerList) {
          params.append('field_id[]', String(ownerList[j]))
        }
        url.search = params.toString()
      }
    } else {
      params.append('planting_id', id)
      url.search = params.toString()
    }

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new FieldDetailsApi()
